import React from 'react'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'
import NameField from '../Namefield'
import AlsoKnownAs from '../AlsoKnownAs'
import ShortBioField from '../ShortBioField'
import PlaceofBirth from '../PlaceofBirth'
import Dob from '../Dob'
import Wikipedia from '../Wikipedia'
import PersonPoster from '../personposter'
import TextAreaWithLink from './TextAreaWithLink'
import GptComponentPerson from '../GptComponentPerson'

function BasicInfoUi(props) {
  const {
    activeSection,
    handleSectionClick,
    PersoninputData,
    personName,
    personNamete,
    error,
    sendInputPersondata,
    sendValuechangedBoolean,
    shortBio,
    shortBiote,
    valueChanged,
    updateInputPersonData,
    wikipediaURL,
    section,
    getUpdatedData,
    setShortbio,
    setShortbiote,
    handleWikipediaURLChange,
    handleNameChange,
    handleNameteChange,
    handleShortbioChange,
    handleShortbioteChange,
    saveBasicInfo,
    validation,
    handleTextAreaChange,
    mode,
  } = props
  return (
    <div
      id={section}
      className={`accordion-item ${
        activeSection === section || activeSection === 'all' ? 'active' : ''
      }`}
    >
      <h2 className='accordion-header' id='headingOne'>
        <button
          className='accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseOne'
          aria-expanded={activeSection === section || activeSection === 'all'}
          aria-controls='collapseOne'
          onClick={() => handleSectionClick(section)}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            color: 'white',
          }}
        >
          {}
          <span>Basic Info</span>
          {}
          {activeSection === section || activeSection === 'all' ? <FaCaretUp /> : <FaCaretDown />}
        </button>
      </h2>
      <div
        id='collapseOne'
        className={`accordion-collapse collapse ${
          activeSection === section || activeSection === 'all' ? 'show' : ''
        }`}
        aria-labelledby='headingOne'
        data-bs-parent='#accordion'
      >
        <NameField
          personName={personName}
          personNamete={personNamete}
          error={error}
          handleNameChange={handleNameChange}
          handleNameteChange={handleNameteChange}
        />
        <AlsoKnownAs
          inputData={PersoninputData}
          sendinputdata={sendInputPersondata}
          sendBooleanValueChangeDone={sendValuechangedBoolean}
        />
        <ShortBioField
          shortbio={shortBio}
          shortbiote={shortBiote}
          error={error}
          handleShortbioChange={handleShortbioChange}
          handleShortbioteChange={handleShortbioteChange}
          setShortbio={setShortbio}
          setShortbiote={setShortbiote}
          sendValuechangedBoolean={sendValuechangedBoolean}
        />
        <GptComponentPerson
          personName={personName}
          Dob={PersoninputData && PersoninputData.dateOfBirth ? PersoninputData.dateOfBirth : ''}
        />
        <PlaceofBirth
          truevalue={valueChanged}
          sendValuechangedBoolean={sendValuechangedBoolean}
          inputData={PersoninputData}
          sendinputdata={sendInputPersondata}
        />
        <Dob
          truevalue={valueChanged}
          inputData={PersoninputData}
          sendtruevalue={sendValuechangedBoolean}
          sendinputdata={sendInputPersondata}
          sendDob={(fieldname, fieldvalue) => updateInputPersonData(fieldname, fieldvalue)}
        />
        <TextAreaWithLink
          //   key={index}
          type={'basic'}
          labels={['Almamater_En', 'Almamater_Te']}
          placeholders={['Enter almamater in english', 'Enter Almamater in Telugu']}
          value={[PersoninputData.Almamater_En || '', PersoninputData.Almamater_Te || '']}
          onChange={newValue => handleTextAreaChange(newValue)}
          setChangesMade={sendValuechangedBoolean}
        />
        <Wikipedia
          wikipediaURL={wikipediaURL}
          error={error}
          handleWikipediaURLChange={handleWikipediaURLChange}
        />
        <PersonPoster
          personPoster={PersoninputData.personPoster}
          truevalue={valueChanged}
          sendtruevalue={sendValuechangedBoolean}
          sendposterurl={(fieldname, fieldvalue) => updateInputPersonData(fieldname, fieldvalue)}
        />
        <div
          className='d-flex'
          style={{ justifyContent: 'center', alignItems: 'center', gap: '5px', marginTop: '5px' }}
        >
          <button
            className='btn btn-success'
            onClick={() => saveBasicInfo()}
            disabled={!validation()}
          >
            {mode === 'create' ? 'create' : 'save'}
          </button>
          {mode !== 'create' && (
            <button className='btn btn-secondary' onClick={() => getUpdatedData()}>
              cancel
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default BasicInfoUi
